import axios from "axios";


export const addApiKey = async (token, data) => {
   
    const response = await axios.post(`${process.env.API_URL}/integration`,
        data,
        {
          withCredentials: true,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': '*/*',
            'content-type': 'application/json'
    
          }
        });
      return response;
  };

  export const getApiKey = async (token, id) => {

    const response = await axios.get(`${process.env.API_URL}/integration/company/${id}`,       
        {
          withCredentials: true,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': '*/*',
            'content-type': 'application/json'
    
          }
        });
      return response;
  };